import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePartyInputClass;
function DeletePartyInput() {
  if (DeletePartyInputClass === VOID) {
    class $ {
      constructor(partyId) {
        this.i6p_1 = partyId;
      }
      toString() {
        return 'DeletePartyInput(partyId=' + this.i6p_1.toString() + ')';
      }
      hashCode() {
        return this.i6p_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePartyInput()))
          return false;
        if (!this.i6p_1.equals(other.i6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePartyInput');
    DeletePartyInputClass = $;
  }
  return DeletePartyInputClass;
}
//region block: exports
export {
  DeletePartyInput as DeletePartyInput19hgu5jgthqub,
};
//endregion

//# sourceMappingURL=DeletePartyInput.mjs.map
